import { render } from "./DeleteProductItemModal.vue?vue&type=template&id=6431cf65"
import script from "./DeleteProductItemModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__